<label class="data-label" *ngIf="label">{{ label }}</label>
<ng-select [ngClass]="selectClass" [ngModel]="selectedValue" (ngModelChange)="onSelectChange($event)"
(search)="onSearch($event)" (focus)="onFocus($event)" [addTag]="isAddTag" [clearable]="clearable"
[placeholder]="selectPlaceholder" *ngIf="!multiSelect" class="custom-clear-icon">
<ng-container *ngIf="isCustom">
  <ng-option *ngFor="let option of options" [value]="option">{{ formatOption(option, customDisplayOption) }}</ng-option>
</ng-container>
<ng-container *ngIf="!isCustom">
  <ng-option *ngFor="let option of options" [value]="option">{{ displayOption(option) }}</ng-option>
</ng-container>
</ng-select>
<ng-select [ngClass]="selectClass" [(ngModel)]="selectedValue" (ngModelChange)="onSelectChange($event)"
  [placeholder]="selectPlaceholder" [multiple]="multiSelect" *ngIf="multiSelect" [clearable]="clearable">
  <ng-option *ngFor="let option of options" [value]="option"> {{ displayOption(option) }}</ng-option>
</ng-select>
